"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const PictureView = ({ imageThumb, imageMedium, alt, }) => react_1.default.createElement("picture", null,
    react_1.default.createElement("source", { srcSet: `${imageThumb} 1x, ${imageMedium} 2x`, media: "(max-width: 939px), (min-width: 1200px)" }),
    react_1.default.createElement("source", { srcSet: `${imageMedium} 800w`, media: "(min-width: 940px) and (max-width: 1199px)" }),
    react_1.default.createElement("img", { itemProp: "image", className: "img-inner", src: imageThumb, alt: alt, loading: "lazy" }));
exports.default = PictureView;
